import React, { useEffect, useState } from 'react'
import { useI18n } from 'contexts/AuthContext'
import ContentHeader from '../ContentHeader'
import { Button } from 'antd'
import classnames from 'classnames'
import thanksForYourInterestIcon from '../img/ic-thanks-for-your-interest.svg'
import styles from './thanksForYourInterest.module.scss'
import { logBrazeEvent } from 'utils/brazeInit'
import { getFitOnHost } from 'apis/formatUrl'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { getMbiFailedInfo } from './mbiFailedCache'
import { getAutoLoginParams, isMobile } from 'utils/basic'
import { mcaScreenerPromise } from 'apis/FitOnCareAPI'
import { getUserEmail } from 'utils/authLocalStorage'

const ThanksForYourInterest = (props) => {
  const { sku } = props
  const { i18n } = useI18n()
  const [currentFitonUserId, setCurrentFitonUserId] = useState()
  useEffect(() => {
    if (sku === 'mca') {
      mcaScreenerPromise().then((resp) => {
        const fitonUserId = resp.data?.fitonUserId?.toString()
        setCurrentFitonUserId(fitonUserId)
      })
    }
  }, [sku])
  const onBack = (e) => {
    props.setRemoveEventListener(false)
    props.onBack(e)
  }
  useEffect(() => {
    logBrazeEvent(`User Denied: Control Group - ${sku}`)
    logAmplitudeEvent('Screen View: Onboarding - Not Available', {
      Reason: getMbiFailedInfo().unavailableReason || 'Control Group',
      Detail: getMbiFailedInfo().unavailableDetail,
      sku,
    })
  }, [sku])

  const onNext = () => {
    window.location.href = `${getFitOnHost()}?${getAutoLoginParams({ fitOnUserId: currentFitonUserId, fitOnEmail: getUserEmail() })}`
  }

  return (
    <div className={classnames(styles.styles, 'info-sec')}>
      <ContentHeader {...props} onBack={onBack} hideBack={true} />
      <div className='info-content'>
        <img src={thanksForYourInterestIcon} alt='' className='top-icon' />
        <div className='title-pns'>
          {i18n('You are not eligible to enroll')}
        </div>
        <div
          className='subtitle'
          style={{
            marginBottom: '10px',
            marginTop: '17px',
            fontFamily: 'AktivGrotesk',
            lineHeight: '24px',
            fontSize: '16px',
          }}
        >
          {i18n(
            'These services are part of a federal payment model test being conducted by the Centers for Medicare & Medicaid Services (CMS). To evaluate the model, some individuals are assigned to a comparison group and are not eligible to enroll for 12 months. This is a random assignment made by CMS for evaluation purposes only and is not based on anything about you or your health. You may continue to receive other services as usual and your Medicare coverage, benefits, and rights are not affected in any way. If you have questions, you may call {0}. Teletypewriter (TTY) users call {1}.',
            <b>1-800-MEDICARE (1-800-633-4227)</b>,
            <b>1-877-486-2048</b>
          )}
        </div>
        <Button
          className='btn-primary full-width-btn'
          style={{ width: '100%', marginTop: '14px' }}
          onClick={onNext}
        >
          {isMobile() ? i18n('Back to App') : i18n('Close')}
        </Button>
      </div>
    </div>
  )
}

export default ThanksForYourInterest
